// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Make the tag input have portalLinkColor or BAI default colors */
body tags-input .tags .tag-item {
  background: #1eabe3;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/premiumAdmin/tagInput.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,mBAAmB;AACrB","sourcesContent":["/* Make the tag input have portalLinkColor or BAI default colors */\nbody tags-input .tags .tag-item {\n  background: #1eabe3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
